import OTPDirectionsAPI from 'js/services/otp_directions_api'
import routesFilterService from 'js/services/routes-filter'

export async function executeGoToPlanner(plannerData, options) {
  const {
    determineErrorMessage,
    onPlannerStateReset,
    sortRoutes,
    translate
  } = options

  const transportModeCalls = plannerData.transportModeCalls
  const allRoutes = []
  const { originDirection, destinationDirection } = plannerData
  let showErrorMessage

  for (const modes of transportModeCalls) {
    const modesToUse = modes.join(',')
    const OTPParams = {
      origin: plannerData.origin,
      destination: plannerData.destination,
      mode: modesToUse
    }

    try {
      const response = await OTPDirectionsAPI.index({
        transitOptions: plannerData.transitOptions,
        origin: plannerData.originCoordinates,
        destination: plannerData.destinationCoordinates,
        administrativeAreaTimeZone: plannerData.administrativeAreaTimeZone,
        otp_url: plannerData.otp_url,
        originDirection,
        destinationDirection,
        selectedTime: plannerData.selectedTime,
        params: OTPParams
      })

      if (response && response.routes && response.routes.length > 0) {
        allRoutes.push(...response.routes)
      }
    } catch (error) {
      showErrorMessage = determineErrorMessage(error, allRoutes)
      onPlannerStateReset()
    }
  }

  if (allRoutes.length === 0) {
    return {
      routes: [],
      noRoutesAvailable: true,
      showErrorMessage: translate('planner.noRoute')
    }
  }

  const responseWithRoutes = { routes: allRoutes }

  let filteredRoutes = routesFilterService.filterRoutesBySelectedOperators(
    responseWithRoutes,
    plannerData.selectedOperators,
    plannerData.operatorOptions
  )

  const maxWalkingTime = parseInt(plannerData.selectedTime, 10)
  filteredRoutes = routesFilterService.filterRoutesByWalkingTime(filteredRoutes, maxWalkingTime)

  const finalRoutes = routesFilterService.processRoutesForModes(
    filteredRoutes,
    plannerData.selectedTransports
  )

  return {
    routes: sortRoutes(finalRoutes.routes),
    noRoutesAvailable: finalRoutes.routes.length === 0,
    showErrorMessage
  }
}
